import { useNavigate, useLocation } from 'react-router-dom';
import {
  IoHomeOutline,
  IoBookOutline,
  IoPeopleOutline,
  IoStatsChartOutline,
  IoCloseOutline,
  IoLogOutOutline,
  IoSettingsOutline,
  IoShieldCheckmarkOutline,
  IoBusinessOutline
} from 'react-icons/io5';
import { useAuth } from '../contexts/AuthContext';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();

  const navigationItems = [
    { id: 'home', label: 'Home', icon: IoHomeOutline, path: '/' },
    { id: 'reading', label: 'Read', icon: IoBookOutline, path: '/reading' },
    { id: 'progress', label: 'My Progress', icon: IoStatsChartOutline, path: '/progress' },
    {
      id: 'church',
      label: 'My Church',
      icon: IoBusinessOutline,
      path: '/church',
      matchPaths: ['/church', '/church-management']
    },
    { id: 'family', label: 'Family', icon: IoPeopleOutline, path: '/family' },
    { id: 'settings', label: 'Settings', icon: IoSettingsOutline, path: '/settings' },
    ...(user?.isAdmin
      ? [{ id: 'admin', label: 'Admin', icon: IoShieldCheckmarkOutline, path: '/admin/dashboard', matchPaths: ['/admin'] }]
      : [])
  ];

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  const handleLogout = async () => {
    await logout();
    onClose();
  };

  const isItemActive = (item) => {
    const path = location.pathname;
    const candidates = item.matchPaths || [item.path];
    return candidates.some((candidate) => {
      if (candidate === '/') return path === '/';
      return path === candidate || path.startsWith(`${candidate}/`);
    });
  };

  return (
    <>
      <aside className={`sidebar ${isOpen ? 'sidebar--open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-title-container">
            <img src="/logo.jpeg" alt="ReadTheWord Logo" className="sidebar-logo" />
            <h2 className="sidebar-title">ReadTheWord</h2>
          </div>
          <button
            className="sidebar-close-button"
            onClick={onClose}
            aria-label="Close menu"
          >
            <IoCloseOutline size={24} />
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul className="nav-list">
            {navigationItems.map((item) => {
              const IconComponent = item.icon;
              const isActive = isItemActive(item);
              return (
                <li key={item.id} className="nav-item">
                  <button
                    className={`nav-link ${isActive ? 'active' : ''}`}
                    onClick={() => handleNavigation(item.path)}
                  >
                    <IconComponent className="nav-icon" size={20} />
                    <span className="nav-label">{item.label}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <button
            className="logout-button"
            onClick={handleLogout}
          >
            <IoLogOutOutline className="logout-icon" size={20} />
            <span>Sign out</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
